module.exports = __webpack_public_path__ + "img/company 5@2x.ba519afb.png";